import stringify from './scss-stringify';
import parse     from './scss-parse';

export default { parse, stringify };
